import JSONViewer from '@/components/common/debug/JSONViewer';
import { useApplication } from '@/hooks/useApplication';
import { useMetadataBlock } from '@/hooks/useMetadataBlock';
import { SelectNode } from '@/types/backendNode';
import { findSubroutine } from '@/util/application';
import { isStartBlock } from '@/util/blocks';
import { Collapse, Divider, Stack } from '@mui/material';
import { FC } from 'react';

type BlockDebugViewProps = {
  open: boolean;
  blockProps: {
    node: SelectNode;
    pinNode: (isPinned: boolean) => void;
    onClose: () => void;
  };
};

const BlockDebugView: FC<BlockDebugViewProps> = (props) => {
  const { metadataBlock } = useMetadataBlock();
  const { application } = useApplication();
  if (!metadataBlock) return <></>;

  const details = application.blocks.details[props.blockProps.node.id.toString()];
  const events =
    application.blocks.event_handlers && application.blocks.event_handlers[props.blockProps.node.id.toString()];

  const getSubroutine = isStartBlock(metadataBlock.type)
    ? application.subroutines.find((sub) => sub.startblock === props.blockProps.node.id)
    : findSubroutine(application.subroutines, props.blockProps.node.id);

  return (
    <Collapse in={props.open}>
      <Stack gap={2} pb={2}>
        <JSONViewer title='React props' collapsed src={props.blockProps || {}} />
        <JSONViewer title='Metadata' src={metadataBlock || {}} collapsed />
        <JSONViewer title='Connections' src={application.blocks.connections[props.blockProps.node.id]} collapsed />
        {metadataBlock.style === 'subroutine' ? (
          <JSONViewer title='Subroutine' src={getSubroutine || application.subroutines[0]} />
        ) : (
          <JSONViewer title='Details' src={details || {}} collapsed />
        )}
        {events && <JSONViewer title='Events' src={events} />}
        <Divider />
      </Stack>
    </Collapse>
  );
};

export default BlockDebugView;
